import type { TrackType } from '@/shared/store/tracks.store.tsx'
import { useSpeechStore } from '@/shared/store/speech.store.ts'

export interface Clip {
  id: string
  type: TrackType
  speechType?: 'tts' | 'sts'
  trackId: string
  name: string
  startAt: number | undefined
  lastPosition?: number | undefined
  isOverlapping?: boolean
  startOffset: number
  duration: number
  endOffset: number
  mediaId: string
  src?: string | undefined
  fadeIn: number
  fadeOut: number
}

export const isVoiceClip = (clip?: Clip): boolean => {
  if (!clip) return false

  const { speeches } = useSpeechStore.getState()
  return !!speeches[clip.mediaId]
}
